export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "en": {
        "srDismissAlert": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dismiss Alert"])}
      },
      "fr": {
        "srDismissAlert": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Annuler l'alerte"])}
      }
    }
  })
}
